/*
 * @Author: mayanxia 
 * @Date: 2022-08-22 16:41:09 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-08-23 14:11:03
 */

<!--增加补水操作员-->
<template>
    <a-modal
        :title="title"
        :width="800"
        :visible="visible"
        :confirmLoading="confirmLoading"
        :okButtonProps="{ props: {disabled: disableSubmit} }"
        :maskClosable="maskClosable"
        @ok="handleOk"
        @cancel="handleCancel"
        :cancelText="$t('关闭')">

        <a-spin :spinning="confirmLoading">
        <a-form-model ref="formModal" :model="model" :rules="rules" :colon="false" layout="vertical">
            <div>
                <a-row :gutter="24">
                    <a-col :xl="8" :lg="7" :md="8" :sm="24">
                        <a-form-model-item :label="$t('审核员')" prop="auditorName">
                            <a-select v-model="model.auditorName" :placeholder="$t('请选择审核员')" show-search>
                                <a-select-option v-for="data in userList" :key="data.id" :value="data.username">
                                {{data.username}}({{data.phone?data.phone: '--'}})
                                </a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                    <a-col :xl="8" :lg="7" :md="8" :sm="24">
                        <a-form-model-item :label="$t('是否启用')" prop="isStart">
                            <a-switch v-model="model.isStart" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :xl="24" :lg="24" :md="24" :sm="24">
                        <a-form-model-item :label="$t('操作员')" prop="operatorName">
                            <a-select v-model="model.operatorName" :placeholder="$t('请选择审核员')" show-search mode="multiple">
                                <a-select-option v-for="data in userList" :key="data.id" :value="data.username">
                                {{data.username}}
                                </a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>

                    <a-col :xl="24" :lg="24" :md="24" :sm="24">
                        <a-form-model-item :label="$t('描述')" prop="remark">
                            <a-textarea v-model="model.remark" rows="3" :placeholder="$t('请输入备注')" style="width:100%"/>
                        </a-form-model-item>
                    </a-col>
                </a-row>
            </div>
        </a-form-model>
        </a-spin>
    </a-modal>
</template>

<script>
    import { httpAction,getAction } from '@/api/manage'
    import { listSize } from '@/utils/util'
    import { mapGetters } from 'vuex'
    
    export default {
        name: 'AuditUserLinkModal',
        props: {
            //表单禁用
            disabled: {
                type: Boolean,
                default: false,
                required: false
            }
        },
        data () {
            return {
                title:this.$t('操作'),
                visible: false,
                disableSubmit:false,
                maskClosable:false,
                model: {
                    isStart: false
                },
                confirmLoading: false,
                url: {
                    add: "/auditprocess/auditUserLink/add",
                    edit: "/auditprocess/auditUserLink/edit",
                    user: "/sys/user/departUserList",  //操作员列表
                    deptList: "/sys/sysDepart/getDepartName"
                },
                userList:[],  
            }
        },
        computed: {
            rules(){
                return {
                    auditorName:[
                        { required: true, message: this.$t('请选择审核员')}
                    ],
                    operatorName:[{ required: true, message: this.$t('请选择操作员')}
                    ],
                }
            },
        },
        created () {
        
        },
        methods: {
            ...mapGetters(["userInfo"]),
            handleOk() {
                console.log("点击提交")
                // 触发表单验证
                this.$refs.formModal.validate(valid => {
                    if(valid) {
                      this.confirmLoading = true;
                      let httpurl = '';
                      let method = '';
                      if(!this.model.id){
                        httpurl+=this.url.add;
                        method = 'post';
                      }else{
                        httpurl+=this.url.edit;
                        method = 'put';
                      }
                      let formData = {...this.model};
                      if(formData.isStart) {
                        formData.isStart = 1;
                      }else{
                        formData.isStart = 0;
                      }
                      formData.operatorName = this.model.operatorName.join(',');
                        httpAction(httpurl,formData,method).then((res) => {
                          this.confirmLoading = false
                          if(res.success){
                              this.$message.success(res.message)
                              this.$emit('ok')
                              this.close()
                          }else{
                              this.$message.warning(res.message)
                          }
                      })
                    }else{
                        return false
                    }
                })
            },
            add() {
                this.edit({});
            },
            edit (record) { 
                this.visible = true;
                this.model = Object.assign(this.model,record);
                if(this.model.id) {
                    this.model.isStart = this.model.isStart == 1?true: false
                }
                this.queryUserList();
            },
            close () {
                this.$emit('close');
                this.$refs.formModal.resetFields()
                this.model = this.$options.data.call(this).model
                this.disableSubmit = false;
                this.visible = false;
            },

            handleCancel () {
                this.close();
            },
            changeAuditor(value,option) {
                console.log(value)
                console.log(option)
            },
            queryUserList() { //操作员请求
                getAction(this.url.deptList, {pageNo: 1,pageSize: 1,orgCode: this.userInfo().orgCode}).then((res) => {
                if(res.success&&res.result.id){
                    let params = {}
                    params.pageNo = 1;
                    params.pageSize = listSize;
                    console.log(this.userInfo())
                    params.depId = res.result.id;
                    getAction(this.url.user, params).then((res) => {
                    if(res.success){
                        this.userList = res.result.records;
                    }
                    }) 
                }
                })
            },
        }
    }
</script>
<style scoped>
    .ant-form-item >>> .ant-select{
    width: 100%;
    }
    .span {
    margin: 8px;
    }
    .detail-list >>> .content{
    line-height: normal;
    }
</style>